function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.33 14.67c-1.05-1.05-1.88-.71-2.6 0l-4.15 4.15c-.16.16-.31.47-.35.69L14 21.1c-.08.57.32.98.89.89l1.59-.23c.22-.03.53-.19.69-.35l4.15-4.15c.73-.71 1.06-1.54.01-2.59zM8.39 2.17v6.45H1.93v-.68c0-3.61 2.15-5.76 5.76-5.76h.7v-.01zm13.38 5.76c0 .38-.31.68-.68.68h-5.75V2.16h.67c3.18.01 5.76 2.59 5.76 5.77zM8.39 15.55v5.76c0 .38-.31.68-.68.68H7.7c-3.18 0-5.76-2.58-5.76-5.76v-.68h6.45z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M8.4 8.61H1.94v6.94H8.4V8.61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.33 8.61v5.94c0 .55-.45 1-1 1H8.39V8.61h6.94z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M15.33 2.17H8.39v6.45h6.94V2.17z"
})));